import { render, staticRenderFns } from "./transition-slide.vue?vue&type=template&id=410ccb69&"
import script from "./transition-slide.ts?vue&type=script&lang=ts&"
export * from "./transition-slide.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports